import React from "react";
import "./MailUs.css";
import mail from "../../../assets/images/email (2).png";
import { useNavigate } from "react-router-dom";


const MailUs = () => {

  const navigate = useNavigate();
  return (
    <>
      <div className="container-fluid mailus-bg">
        <div className="container">
          <div className="row mail-row">
            <div className="col-md-6">
              <div className="mail-content-first">
                <p className="mail-content-obtain">
                  Obtaining further
                  <br /> information by{" "}
                  <span style={{ color: "#00436b" }}>
                    make a<br /> contact
                  </span>{" "}
                  with our
                  <br />
                  experienced IT staffs.
                </p>
                <p className="mail-content-contact">
                  Contact to require a detailed analysis and
                  <br /> assessment of your plan.
                </p>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-center align-items-center">
              <div className="mail-content-second">
                {/* <img src={mail} alt="mail-icon" />
                <p>REACH OUT NOW</p> */}
                {/* <h4>aravinthkumaran410@gmail.com</h4> */}
                <button onClick={() => navigate('/contact')}>Contact Us</button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MailUs;
